export enum CalculatorTypes {
  OPEN_BRACKET = 'open_bracket',
  CLOSE_BRACKET = 'close_bracket',
  NUMBER = 'number',
  OPERATOR = 'operator',
  METRIC = 'metric',
}
